import type { Translatable } from "app/pages/sales-intelligence/types";

/**
 * Banner-specific translation keys (low-credits banner variants)
 */
export const bannerKeys = {
    userTitle: "si.quota.low-credits.banner.user.title",
    userDescription: "si.quota.low-credits.banner.user.description",
    userButton: "si.quota.low-credits.banner.user.button-text",

    adminTitle: "si.quota.low-credits.banner.admin.title",
    adminDescription: "si.quota.low-credits.banner.admin.description",
    adminButton: "si.quota.low-credits.banner.admin.button-text",

    noTouchTitle: "si.quota.low-credits.banner.no_touch.title",
    noTouchDescriptionAddon: "si.quota.low-credits.banner.no_touch.description-addon",
    noTouchButton: "si.quota.low-credits.banner.no_touch.button-text",

    insufficientTitle: "si.quota.low-credits.banner.insufficient.title",
    exportMoreCreditsTitle: "si.quota.low-credits.banner.export_data.title",
    revealMoreCreditsTitle: "si.quota.low-credits.banner.reveal.title",
} as const;

/**
 * Type-safe translation key generators for quota translations
 */
export const quotaKeys = {
    toggleExportCost: `si.quota.toggle.show-export-cost.text`,

    quotaTooltip: `si.common.quota.tooltip`,

    quotaCalculationInfo: `si.quota.calculation-info.text`,

    quotaNotifyAdmin: bannerKeys.userButton,

    quotaManageCredits: bannerKeys.adminButton,

    creditsLeft: (replacements: { quota: string | number }): Translatable => ({
        key: "si.quota.credist-left.text",
        replacements,
    }),

    needMoreCreditsTitle: "si.quota.need-more-credits.title",
    insufficientCreditsTitle: bannerKeys.insufficientTitle,
    needMoreCredits: "si.quota.need-more-credits.text",

    trialNeedMoreCredits: "si.quota.trial.need-more-credits.text",

    upgradeNow: "si.common.upgrade_now",

    lowCreditsQuestion: "si.quota.low-credits.question",
    lowCreditsText: "si.quota.low-credits.text",
    lowCreditsLeft: (replacements: { quota: number }): Translatable => ({
        key: "si.quota.low-credits.left.text",
        replacements,
    }),

    websitesQuota: (replacements: { numberOfWebsites: number; limit: number }): Translatable => ({
        key: "si.common.quota",
        replacements,
    }),

    totalCost: (replacements: { creditNumber: string | number }): Translatable => ({
        key: "si.quota.tag.title",
        replacements,
    }),

    totalRowCost: (replacements: { cost: string | number }): Translatable => ({
        key: "si.quota.badge.total-row-cost.text",
        replacements,
    }),

    noExportQuotaLeftForMonth: (replacements: { quota: number }): Translatable => ({
        key: "si.my-lists.section.enrichment.modal.enrich.preview.tooltip.error",
        replacements,
    }),

    exportCostCompetitorDescription: "si.quota.competitor.export.description",
    exportCostInfoDescription: `si.quota.tooltip.allowed.description`,
    exportCostAdjustTitle: `si.quota.tooltip.allowed.button.title`,

    dataCreditsIndicatorLabel: (replacements: { count: number }): Translatable => ({
        key: "si.quota.data-credits.credit-left",
        replacements,
    }),

    dataCreditsExtendedOver90Title: "si.quota.data-credits-extended.tooltip.over-90-title",

    dataCreditsExtendedOver90Description: "si.quota.data-credits-extended.tooltip.over-90-description",

    dataCreditsExtendedNoCreditsTitle: "si.quota.data-credits-extended.tooltip.no-credits-title",

    dataCreditsExtendedNoCreditsDescription: "si.quota.data-credits-extended.tooltip.no-credits-description",

    noTouchDescriptionAddon: "si.quota.low-credits.banner.no_touch.description-addon",
} as const;
